import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import moment from "moment";
import {createDsScoutingClient} from "@/api/ds_scouting";
import {getDsContext} from "@/utils/dsContext";
import {dsPlayerScoutingSummary, dsProviderSeason} from "@/utils/dsScouting";
import {formatAverage, getVerdict} from "@/utils/scoutingReports";
import AiProfileCard from "@/components/AiProfileCard";
import {DsSection, DsEmpty, DsTable, DsLink} from "@/components/DsKit";
export default function DsPlayerScouting({playerId, snapshot}) {
	const context = useSelector(getDsContext),
		season = snapshot.season;
	const key = dsProviderSeason(season);
	const [source, setSource] = useState(null),
		[error, setError] = useState(false),
		[retry, setRetry] = useState(0);
	useEffect(() => {
		let active = true;
		setSource(null);
		setError(false);
		const client = createDsScoutingClient();
		Promise.all([
			client.profile(playerId),
			key ? client.indices(playerId, key) : Promise.resolve(null),
		])
			.then(([profile, indices]) => {
				if (active && context === getDsContext())
					setSource({profile, indices, key});
			})
			.catch(() => {
				if (active && context === getDsContext()) setError(true);
			});
		return () => {
			active = false;
		};
	}, [playerId, season.id, key, context, retry, snapshot.loadedAt]);
	const summary = dsPlayerScoutingSummary(snapshot, playerId);
	return (
		<DsSection
			title="Scouting condiviso"
			hint="Relazioni e visioni della stagione selezionata; profilo corrente del club."
			action={
				<DsLink to={"/scouting/players/" + playerId}>
					Scheda scouting completa
				</DsLink>
			}
		>
			<div className="ds-facts">
				<div className="ds-facts__row">
					<span>Relazioni</span>
					<b>{summary.reports.length}</b>
				</div>
				<div className="ds-facts__row">
					<span>Media relazioni</span>
					<b>{formatAverage(summary.average)}</b>
				</div>
				<div className="ds-facts__row">
					<span>Visioni</span>
					<b>{summary.visions.length}</b>
				</div>
			</div>
			{summary.last && (
				<p>
					{getVerdict(summary.last.verdict)?.label || summary.last.verdict} ·{" "}
					{summary.last.author?.name} ·{" "}
					{moment(summary.last.reportDate).format("DD/MM/YYYY")} —{" "}
					{summary.last.judgment}{" "}
					<DsLink to={"/scouting/relazioni/" + summary.last.id}>
						Leggi relazione
					</DsLink>
				</p>
			)}
			{error ? (
				<DsEmpty>
					Sintesi scouting non disponibile o accesso non consentito.{" "}
					<button onClick={() => setRetry((n) => n + 1)}>
						Riprova sintesi scouting
					</button>
				</DsEmpty>
			) : source ? (
				<>
					<AiProfileCard
						profile={source.profile.profile}
						outdated={source.profile.outdated}
						available
					/>
					{!source.key ? (
						<DsEmpty>
							Periodo Wyscout non disponibile per questa stagione.
						</DsEmpty>
					) : source.indices?.datasetVersion > 0 ? (
						<>
							<p>Indici Wyscout · {source.key} · sole gare ufficiali</p>
							<DsTable
								columns={[
									{key: "label", label: "Indice", render: (r) => r.index.label},
									{
										key: "score",
										label: "Punteggio",
										render: (r) =>
											r.index.score == null ? "—" : Math.round(r.index.score),
									},
								]}
								rows={source.indices.indices}
								rowKey={(r) => r.index.id}
							/>
						</>
					) : (
						<DsEmpty>
							Nessuna statistica Wyscout condivisa per questo giocatore.
						</DsEmpty>
					)}
				</>
			) : (
				<p>Caricamento profilo e indici scouting…</p>
			)}
		</DsSection>
	);
}
